import { LazyLoad } from 'app/utils';

export const CategoryContactListPage = LazyLoad(
  () => import('./index'),
  (module) => module.CategoryContactListPage,
);
